<template>
    <Header></Header>
    <Left></Left>
    <section class="container">
        <div class="blue_box _full">
            <div class="box_tit _flex">
                <h2>시민제보창</h2>
            </div>

            <div class="sch_condition_wrap">
                <div class="left _column _flex">
                    <div class="checkbox_wrap sch_list">
                        <label for="chk_all">
                            <input id="chk_all" type="radio" v-model="state.type" :value="0" @change="toggleAllRole" checked />
                            <em></em>
                            <span>전체</span>
                        </label>
                        <label v-for="item in typeList" :key="item.key">
                            <input type="radio" :value="item.key" v-model="state.type" @change="handleRoleChange" />
                            <em></em>
                            <span>{{ item.value }}</span>
                        </label>
                    </div>
                    <div class="_flex _align_bottom _multi" style="z-index: 3">
                        <div class="select_tab_box_wrap">
                            <span class="sch_list_tit">상태값</span>
                            <div class="select_tab_box _130">
                                <div
                                    class="selected_tab"
                                    :class="{ active: state.isShowStateType }"
                                    @click="state.isShowStateType = !state.isShowStateType"
                                >
                                    <span>{{ state.detailStateTxt }}</span>
                                </div>
                                <div class="tab_option" v-show="state.isShowStateType">
                                    <button
                                        type="button"
                                        @click="
                                            state.state = 0;
                                            state.detailStateTxt = '전체';
                                            state.isShowStateType = false;
                                            state.page = 1;
                                            getList();
                                        "
                                    >
                                        전체
                                    </button>
                                    <button
                                        type="button"
                                        @click="
                                            state.state = 1;
                                            state.detailStateTxt = '대기중';
                                            state.isShowStateType = false;
                                            state.page = 1;
                                            getList();
                                        "
                                    >
                                        대기중
                                    </button>
                                    <button
                                        type="button"
                                        @click="
                                            state.state = 2;
                                            state.detailStateTxt = '접수완료';
                                            state.isShowStateType = false;
                                            state.page = 1;
                                            getList();
                                        "
                                    >
                                        접수완료
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="select_tab_box_wrap">
                            <span class="sch_list_tit">조치</span>
                            <div class="select_tab_box _130">
                                <div
                                    class="selected_tab"
                                    :class="{ active: state.isShowIsReportType }"
                                    @click="state.isShowIsReportType = !state.isShowIsReportType"
                                >
                                    <span>{{ state.detailIsReportTxt }}</span>
                                </div>
                                <div class="tab_option" v-show="state.isShowIsReportType">
                                    <button
                                        type="button"
                                        @click="
                                            state.isReport = 0;
                                            state.reportState = 0;
                                            state.detailIsReportTxt = '전체';
                                            state.isShowIsReportType = false;
                                            state.page = 1;
                                            getList();
                                        "
                                    >
                                        전체
                                    </button>

                                    <button
                                        type="button"
                                        @click="
                                            state.isReport = 1;
                                            state.reportState = 1;
                                            state.detailIsReportTxt = '가능';
                                            state.isShowIsReportType = false;
                                            state.page = 1;
                                            getList();
                                        "
                                    >
                                        신고 가능
                                    </button>
                                    <button
                                        type="button"
                                        @click="
                                            state.isReport = 1;
                                            state.reportState = 2;
                                            state.detailIsReportTxt = '가능';
                                            state.isShowIsReportType = false;
                                            state.page = 1;
                                            getList();
                                        "
                                    >
                                        고발 가능
                                    </button>
                                    <button
                                        type="button"
                                        @click="
                                            state.isReport = 2;
                                            state.reportState = 0;
                                            state.detailIsReportTxt = '불가능';
                                            state.isShowIsReportType = false;
                                            state.page = 1;
                                            getList();
                                        "
                                    >
                                        불가능
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="select_date_wrap">
                            <div class="select_date">
                                <input type="date" @keydown.enter="searchDate" name="" id="" v-model="form_state.startDate" @change="getList" />
                            </div>
                            <div class="select_date">
                                <input
                                    style="margin-left: 5px"
                                    type="date"
                                    @keydown.enter="searchDate"
                                    name=""
                                    id=""
                                    v-model="form_state.endDate"
                                    @change="getList"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="sch_condition_wrap">
                <div class="left _column _flex">
                    <div class="_flex _align_bottom _multi">
                        <!-- z-index -->
                        <div class="select_tab_box_wrap">
                            <span class="sch_list_tit">업종분류</span>
                            <div class="select_search_row">
                                <div class="select_tab_box _230">
                                    <div
                                        class="selected_tab"
                                        :class="{ active: state.isShowCategoryType }"
                                        @click="state.isShowCategoryType = !state.isShowCategoryType"
                                    >
                                        <span>{{ state.detailTxt }}</span>
                                    </div>

                                    <div class="tab_option" v-show="state.isShowCategoryType" :class="{ active: state.isShowCategoryType }">
                                        <button
                                            @click="
                                                state.categoryType = 0;
                                                state.detailTxt = '전체';
                                                state.isShowCategoryType = false;
                                                state.page = 1;
                                                getList();
                                            "
                                        >
                                            전체
                                        </button>

                                        <button
                                            v-for="item in state.categoryList"
                                            :key="item.caIdx"
                                            @click="
                                                state.categoryType = item.caIdx;
                                                state.detailTxt = item.caName;
                                                state.isShowCategoryType = false;
                                                state.page = 1;
                                                getList();
                                            "
                                        >
                                            {{ item.caName }}
                                        </button>
                                    </div>
                                </div>
                                <div class="search_wrap">
                                    <input type="text" v-model="state.searchText" @keyup.enter="searchText" placeholder="업소명을 입력하세요." />
                                    <button type="button" class="search_btn icon_wrap" @click="searchText">
                                        <img src="img/search_btn.png" alt="" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="right _align_bottom _flex">
                    <button type="button" class="default_btn _gray" @click="isDelete">삭제</button>
                    <button type="button"><img src="img/excel_icon.png" alt=" 엑셀 다운로드" @click="downloadFile" /></button>
                </div>
            </div>

            <div class="common_table custom_scroll">
                <table>
                    <colgroup>
                        <col style="width: 40px" />
                        <col style="width: 80px" />
                        <col style="width: 180px" />
                        <col />
                        <col style="width: 170px" />
                        <col style="width: 170px" />
                        <col style="width: 120px" />
                        <col style="width: 120px" />
                        <col style="width: 170px" />
                        <col style="width: 60px" />
                        <col style="width: 60px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th class="checkbox_wrap cnt p_5 checkbox_wrap2">
                                <input type="checkbox" v-model="state.checkAll" @change="toggleAll()" />
                            </th>
                            <th>번호</th>
                            <th>게시판 이름</th>
                            <th>업소명</th>
                            <th>작성일</th>
                            <th>분류</th>
                            <th>상태값</th>
                            <th>조치</th>
                            <th>불가능 사유</th>
                            <th>메모</th>
                            <th>수정</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-if="state.list.length > 0">
                            <tr v-for="(item, idx) in state.list" :key="item.idx">
                                <td class="checkbox_wrap cnt p_5 checkbox_wrap2">
                                    <label :for="'chk_main' + item.idx" @click.stop>
                                        <input
                                            type="checkbox"
                                            :id="'chk_main' + item.idx"
                                            v-model="state.checkedList"
                                            :value="item.idx"
                                            @click.stop
                                        />
                                    </label>
                                </td>
                                <td class="list_num">{{ (state.page - 1) * state.size + (idx + 1) }}</td>
                                <td class="underline" :class="[item.type == 1 ? 'blue_tag' : 'green_tag']">
                                    <a
                                        :href="
                                            state.userSiteUrl + '/#/' + (item.type === 1 ? 'report?type=' + item.type : 'report?type=' + item.type)
                                        "
                                        target="_blank"
                                    >
                                        {{ item.type === 1 ? "성매매 의심 업소 제보" : "성매매 알선 광고 제보" }}
                                    </a>
                                </td>
                                <td class="underline">
                                    <a :href="state.userSiteUrl + '/#/' + (item.type === 1 ? 'areaView/' : 'adView/') + item.idx" target="_blank">
                                        {{ item.shopName }}
                                    </a>
                                </td>
                                <!-- <td>{{ item.nickName != null ? item.nickName : "익명" }}</td> -->
                                <td class="cnt p_5">{{ CommonUtils.dateFormat(new Date(item.createDate), ".", true) }}</td>

                                <!-- 분류 -->
                                <td v-if="item.type == 1">{{ item.isSchool == 1 ? "학교주변" : "학교주변 외" }}</td>
                                <td v-else>{{ strAdType(item.adType) }}</td>

                                <td class="cnt">{{ item.state == 1 ? "대기중" : "접수완료" }}</td>

                                <!-- 신고 여부 -->
                                <td v-if="item.isReport != null" class="cnt">
                                    {{ item.isReport == 1 ? (item.reportState === 1 ? "신고가능" : "고발가능") : "불가능" }}
                                </td>
                                <td v-else class="cnt">대기중</td>

                                <!-- 불가능 사유 -->
                                <td v-if="item.isReport == 2">{{ strReason(item.reason) }}</td>
                                <td v-else>-</td>

                                <td class="cnt">{{ item.memo ? "O" : "-" }}</td>
                                <td class="cnt p_5">
                                    <button type="button" class="table_btn _blue" @click="modifyModal(item.type, item.idx)">수정</button>
                                </td>
                            </tr>
                        </template>
                        <tr v-else>
                            <td colspan="10">
                                <div class="tb_subject" style="text-align: center; width: 100%">데이터가 없습니다.</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <PageBtn
                v-if="state.list.length !== 0"
                :currentPage="state.page"
                :totalLength="state.totalLength"
                :perPage="state.size"
                :data="state.data"
                @onPaging="handlePageChange"
            ></PageBtn>
        </div>
    </section>
    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>

    <ReportModal
        v-if="state.isReportShowModal"
        :reportInfo="state.reportInfo"
        :nextInfo="state.nextReport"
        :prevInfo="state.prevReport"
        @close="state.isReportShowModal = false"
        @save="save"
        @next="nextReport()"
        @prev="prevReport()"
    ></ReportModal>
</template>
<script lang="ts" config>
    import {
        userStore,
        globalStore,
        popupStore,
        reactive,
        watch,
        apiService,
        onMounted,
        router,
        Header,
        Left,
        ModalDefault,
        ReportModal,
        types,
        onBeforeUnmount,
        PageBtn,
        CommonUtils,
        useRoute,
        getMessageByCode,
    } from "@/BaseComponent";
    export default {
        props: {},
        components: {
            Header,
            Left,
            ModalDefault,
            ReportModal,

            PageBtn,
        },
        setup() {
            const global = globalStore();
            const user = userStore();
            const popup = popupStore();
            const route = useRoute();

            const state = reactive({
                list: [] as Array<any>,
                categoryList: [] as Array<any>,

                reportInfo: {} as types.ReportVOForApi,
                nextReport: {} as types.ReportVOForApi,
                prevReport: {} as types.ReportVOForApi,

                detailType: null as number | null,
                searchType: "" as string,
                searchText: "" as string,
                startDate: "" as string,
                endDate: "" as string,

                type: 0 as number,
                categoryType: 0 as number,
                state: 0 as number,
                isReport: 0 as number,
                reportState: 0 as number,

                data: {},

                checkAll: false as boolean,
                checkedList: [] as Array<number>,

                page: 1 as number,
                size: 20 as number,
                totalPage: 1 as number,
                totalLength: 0 as number,

                isReportShowModal: false as boolean,
                isShowCategoryType: false as boolean,
                isShowStateType: false as boolean,
                isShowIsReportType: false as boolean,

                detailTxt: "전체" as string,
                detailStateTxt: "전체" as string,
                detailIsReportTxt: "전체" as string,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                selectedType: ["all"],
                userSiteUrl: process.env.VUE_APP_USER_FRONT_ADDRESS,
            });

            const form_state = reactive({
                startDate: "" as string,
                endDate: "" as string,
            });

            const imgError = (e: Event) => {
                const target = e.target as HTMLImageElement;
                if (target) {
                    target.src = require("@/assets/no_img.png");
                }
            };

            onMounted(() => {
                getCategoryList();

                if (route.query.type) {
                    state.type = Number(route.query.type);
                }

                if (route.query.categoryType) {
                    state.categoryType = Number(route.query.categoryType);
                }

                getList();
            });

            onBeforeUnmount(() => {});

            watch(
                () => [state.checkedList, state.list],
                () => {
                    state.checkAll = state.checkedList.length > 0 && state.checkedList.length === state.list.length;
                },
            );

            const handlePageChange = (page: number) => {
                state.page = page;
                getList();
            };

            const closeModal = () => {
                state.isShowModal = false;
                state.modalTab = -1;
            };

            const callBackModal = async (param: any) => {
                if (param.action === "confirm") {
                    deleteCheckList();
                }
            };

            const save = async (type: number, param: types.ReqReportForAnswer) => {
                const res = await apiService.report.modifyForAnswer(type, param);

                if (res.returnCode === 0) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "수정이 완료되었습니다.";
                    state.isShowModal = true;

                    state.isReportShowModal = false;

                    getList();
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "저장에 실패하였습니다.";
                    state.isShowModal = true;
                }
            };

            const typeList = [
                { id: "1", key: 1, value: "성매매 의심 업소 제보" },
                { id: "2", key: 2, value: "성매매 알선 광고 제보" },
            ];

            const strReason = (val: number) => {
                switch (val) {
                    case 1:
                        return "내용부족";
                    case 2:
                        return "주소 불명확";
                    case 3:
                        return "온라인 모니터링 불가";
                    case 4:
                        return "게시판 오신고";
                    case 5:
                        return "중복";
                    default:
                        return "기타";
                }
            };

            const strAdType = (val: number) => {
                switch (val) {
                    case 1:
                        return "온라인 알선 광고";
                    case 2:
                        return "지면 광고";
                    case 3:
                        return "불법 옥외광고물";
                    default:
                        return "기타";
                }
            };

            const toggleAllRole = () => {
                state.page = 1;
                getList();
            };

            const handleRoleChange = () => {
                state.page = 1;
                getList();
            };

            const searchDate = async () => {
                if (form_state.endDate && form_state.startDate && form_state.endDate < form_state.startDate) {
                    form_state.endDate = "";
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "날짜를 올바르게 선택해주세요.";
                    state.isShowModal = true;
                    return;
                }
                state.startDate = form_state.startDate;
                state.endDate = form_state.endDate;
                state.page = 1;
                getList();
            };
            const searchText = () => {
                if (state.searchText && state.searchText.length < 2) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "검색어는 2글자 이상 입력해주세요.";
                    state.isShowModal = true;
                    return;
                }

                state.page = 1;
                getList();
            };

            const getList = async () => {
                state.checkedList = [];
                const param: types.ReqReportListForAdmin = {
                    page: state.page,
                    size: state.size,
                    searchType: state.searchType,
                    searchText: state.searchText,
                    startDate: state.startDate,
                    endDate: state.endDate,

                    type: state.type,
                    categoryType: state.categoryType,
                    state: state.state,
                    isReport: state.isReport,
                    reportState: state.reportState,
                };

                const res = await apiService.report.list(param);
                if (res.returnCode === 0) {
                    state.list = res.list.data;
                    state.totalPage = res.list.totalPages;
                    state.totalLength = res.list.recordsTotal;
                } else {
                    state.list = [];
                    state.totalPage = 0;
                    state.totalLength = 0;
                }
            };

            const getCategoryList = async () => {
                const res = await apiService.category.list();

                if (res.returnCode === 0) {
                    state.categoryList = res.data;
                } else {
                    state.list = [];
                    state.totalPage = 0;
                    state.totalLength = 0;
                }
            };

            const modifyModal = async (type: number, idx: number) => {
                if (type != null && type > 0 && type != undefined && idx != null && idx > 0 && idx != undefined) {
                    const res = await apiService.report.detail(state.type, type, idx);

                    if (res.returnCode === 0) {
                        state.reportInfo = res.data;
                        state.nextReport = res.next;
                        state.prevReport = res.prev;
                        state.isReportShowModal = true;
                    }
                }
            };

            const toggleAll = () => {
                if (state.checkAll) {
                    state.checkedList = state.list.map((item) => item.idx);
                } else {
                    state.checkedList = [];
                }
            };

            const isDelete = () => {
                if (state.checkedList && state.checkedList.length > 0) {
                    state.modalTab = 5;
                    state.modalTitle = "알림";
                    state.modalContent = "정말 삭제하시겠습니까?";
                    state.isShowModal = true;
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "선택된 게시글이 없습니다.";
                    state.isShowModal = true;
                }
            };

            const deleteCheckList = async () => {
                if (state.checkedList && state.checkedList.length > 0) {
                    const res = await apiService.report.multiRemove(state.checkedList.join(","));

                    if (res.returnCode === 0) {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = "삭제가 완료되었습니다.";
                        state.isShowModal = true;

                        getList();
                        state.checkedList = [];
                    } else if (res.returnCode === 11) {
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "예외 발생";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "선택된 게시글이 없습니다.";
                    state.isShowModal = true;
                }
            };

            const downloadFile = async () => {
                try {
                    const param: types.ReqReportListForExcel = {
                        idxList: state.checkedList?.join(","),
                        type: state.type,
                        caIdx: state.categoryType,
                        state: state.state,
                        isReport: state.isReport,
                        startDate: form_state.startDate,
                        endDate: form_state.endDate,
                        searchText: state.searchText,
                    };

                    let res = await apiService.report.exportExcelForReportList(param);

                    if (res && res.data) {
                        const blob = new Blob([res.data], {
                            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        });
                        const disposition = res.headers["content-disposition"];
                        let fileName = "download.xlsx";
                        if (disposition) {
                            const match = disposition.match(/filename="?(.+)"?/);
                            if (match && match[1]) {
                                fileName = decodeURIComponent(match[1]);
                            }
                        }
                        const a = document.createElement("a");
                        const url = window.URL.createObjectURL(blob);
                        a.href = url;
                        a.download = fileName;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        URL.revokeObjectURL(url);
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                } catch (err) {
                    console.error("파일 다운로드 실패:", err);
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "파일 다운로드 실패";
                    state.isShowModal = true;
                }
            };

            const nextReport = () => {
                if (state.nextReport && state.nextReport.idx) {
                    modifyModal(state.nextReport.type, state.nextReport.idx);
                }
            };
            const prevReport = () => {
                if (state.prevReport && state.prevReport.idx) {
                    modifyModal(state.prevReport.type, state.prevReport.idx);
                }
            };

            return {
                state,
                user,
                router,
                imgError,
                types,
                global,
                popup,
                CommonUtils,
                handlePageChange,
                toggleAllRole,
                handleRoleChange,
                getList,
                getCategoryList,
                typeList,
                strReason,
                strAdType,
                searchDate,
                searchText,
                form_state,
                closeModal,
                callBackModal,
                modifyModal,
                save,
                toggleAll,
                isDelete,
                downloadFile,
                nextReport,
                prevReport,
            };
        },
    };
</script>

<style scoped>
    .tab_option.active {
        visibility: visible;
        height: auto;
        opacity: 1;
    }
    .green_tag a {
        color: #20744a;
    }
    .blue_tag a {
        color: var(--main_color);
    }
    .select_search_row {
        display: flex;
        align-items: flex-end;
        gap: 10px;
    }
    /* ._multi {
        z-index: 6;
    } */
</style>
